import Sidebar from "../Component/Sidebar";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import React from "react";
import { useEffect, useState } from "react";
import setting from "../setting.json";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
const MemberList = () => {

    const [list, setList] = useState([]);
    const [data, setData] = useState([]);
    const [updated, setUpdated] = useState(false);

    const [newsCount, setNewsCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [searchList, setSearchList] = useState([]);
    const getAllMember = async () => {
        await fetch(setting.api + "/api/getMemberDetails", {
            method: "GET",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + JSON.parse(localStorage.getItem("loggedUser")).token,
            },
        })
            .then(response => response.json())
            .then(a => {
                setList(a.data);
                setSearchList(a.data);
            }
            );
        // console.log(list);
    }

    useEffect(() => {
        getAllMember();
        setCurrentPage(1);
        setPageCount(Math.ceil((list.length) / pageSize));
        var start = ((currentPage - 1) * pageSize);
        var end = (start + pageSize);
        setData(list.slice(start, end));

    }, []);

    useEffect(() => {
        getAllMember();
        setCurrentPage(1);
        setPageCount(Math.ceil((list.length) / pageSize));
        var start = ((currentPage - 1) * pageSize);
        var end = (start + pageSize);
        setData(list.slice(start, end));

    }, [updated]);
    useEffect(() => {
        setCurrentPage(1);
        setPageCount(Math.ceil((list.length) / pageSize));
        var start = ((currentPage - 1) * pageSize);
        var end = (start + pageSize);
        setData(list.slice(start, end));

    }, [list]);

    useEffect(() => {
        var start = ((currentPage - 1) * pageSize);
        var end = (start + pageSize);
        setData(list.slice(start, end));

    }, [currentPage]);
    useEffect(() => {
        setNewsCount(list.length);

    }, [list]);
    const clickNext = () => {
        if (currentPage === pageCount) {
            setCurrentPage(pageCount);
        } else {
            setCurrentPage(currentPage + 1);
        }
    }
    useEffect(() => {
        var start = ((currentPage - 1) * pageSize);
        var end = (start + pageSize);
        setData(list.slice(start, end));

    }, [currentPage]);
    useEffect(() => {
        setNewsCount(list.length);

    }, [list]);

    const clickPrev = () => {
        if (currentPage === 1) {
            setCurrentPage(1);
        } else {
            setCurrentPage(currentPage - 1);
        }

    }
    const searchMember = async (e) => {
        var text = e.target.value;
        console.log(text);
        const dd = list.filter((u) => (u.fname).search(text) > -1);
        console.log(dd);
        setSearchList(dd);

    }

    return (
        <>
            <div className="min-height-300 bg-primary position-absolute w-100"></div>
            <Sidebar />
            <main className="main-content position-relative border-radius-lg ">
                <Header title="Member List" />
                <div className="container-fluid py-4">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-4">
                                <div className="card-header ">
                                    <Link to="/addmember">
                                        <span className="badge badge-sm bg-gradient-primary add">+Add Member</span>
                                    </Link>
                                </div>
                                <Row>
                                    <Col sm={12} xs={12}>
                                        <div className="ms-md-auto ml-4 d-flex align-items-center search ser"><div className="input-group"><span className="input-group-text text-body"><i className="fas fa-search" aria-hidden="true"></i></span>
                                            <input type="text" className="form-control" placeholder="Enter Name" autocomplete="off"
                                                onChange={(e) => searchMember(e)} />
                                        </div></div>
                                    </Col>

                                </Row>
                                <div className="card-body p-3 pb-0">
                                    <ul className="list-group">
                                        {
                                            searchList && searchList.map((a, i) =>
                                                <li className="list-group-item border-1 d-flex justify-content-between ps-1 mb-2  border-radius-lg " key={a.i}>
                                                    <div className="d-flex flex-column box">
                                                        <h6 className="mb-1 text-dark font-weight-bold text-lg"> {a.fname + ' ' + a.lname}</h6>
                                                        <span className="font-weight-bold text-sm"> {a.phone} <br />  {a.email}</span>
                                                    </div>
                                                    <div className="d-flex align-items-center text-sm  ">


                                                        <Link to={`/updateMember/${a.id}`}>
                                                            <span className="badge badge-sm badge badge-sm bg-dark">
                                                                <i className="fas fa-pencil-alt">
                                                                </i>Edit</span>
                                                        </Link>
                                                    </div>
                                                </li>
                                            )}


                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </main>
        </>
    );
}

export default MemberList;